import { render, staticRenderFns } from "./LogicOvertimeAdd.vue?vue&type=template&id=1a6acb90&scoped=true&"
import script from "./LogicOvertimeAdd.vue?vue&type=script&lang=js&"
export * from "./LogicOvertimeAdd.vue?vue&type=script&lang=js&"
import style0 from "./LogicOvertimeAdd.vue?vue&type=style&index=0&id=1a6acb90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6acb90",
  null
  
)

export default component.exports